<template>
    <div class="meter-order-publicity-template">
      <p style="margin-top:0;margin-right:0;margin-bottom:0;margin-left:0;text-indent:0;padding:0 0 0 0 ">
        <span style=";font-family:宋体;font-size:16px">致：各位业户</span>
      </p>
      <p style="text-align:center">
        <strong><span style="font-family: 宋体;font-size: 21px">通</span></strong><strong><span style="font-family: 宋体;font-size: 21px">&nbsp;</span></strong><strong><span style="font-family: 宋体;font-size: 21px">知</span></strong>
      </p>
      <p style="text-align:center">
        <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span><span style="font-family:宋体">{{year_month}}</span></span><span style="font-family: 宋体;font-size: 14px">份</span><span style=";font-family:宋体;font-size:14px"><span style="font-family:Calibri;color: #ff3d00;">{{publicity.name||'[公示模板名称]'}}</span></span><span style="font-family: 宋体;font-size: 14px">）</span>
      </p>
      <p style="text-indent:32px;text-autospace:ideograph-numeric;line-height:150%">
        <span style=";font-family:宋体;line-height:150%;font-size:16px">根据当地政府的物业管理相关规定，以及与您签订的物业管理合同约定，</span><span style=";font-family:宋体;line-height:150%;font-size:16px">本小区</span><span style=";font-family:宋体;line-height:150%;font-size:16px">的公共能耗费应由各业户按比例共同分摊</span><span style=";font-family:宋体;line-height:150%;font-size:16px">，</span><span style=";font-family:宋体;line-height:150%;font-size:16px"><span style="font-family:宋体">现将</span><span style="font-family:宋体">{{year_month}}份</span></span><span style=";font-family:宋体;line-height:150%;font-size:16px">公摊</span><span style=";font-family:宋体;line-height:150%;font-size:16px">水电费情况公布如下</span><span style=";font-family:宋体;line-height:150%;font-size:16px">，</span><span style=";font-family:宋体;line-height:150%;font-size:16px">&nbsp;<span style="font-family:宋体">望各业户共同监督</span></span><span style=";font-family:宋体;line-height:150%;font-size:16px">：</span>
      </p>
      <div style="display: flex;flex-direction: row;">
        <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">公摊区域：</span></span>
        <SelectProjectTreeComponent width="400px" :project_id="mainObj.project_id" :checked_keys="publicity.house_ids"/>
      </div>
      <table cellspacing="0" border="1" width="100" style="width: 100%;">
        <tbody>
        <tr style="height:31px" class="firstRow">
          <td width="202" valign="center" nowrap="" style="padding: 0px 7px; border-width: 1px; border-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">仪表名称</span></strong>
            </p>
          </td>
          <td width="85" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">上期读数</span></strong>
            </p>
          </td>
          <td width="70" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">本期读数</span></strong>
            </p>
          </td>
          <td width="71" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">倍率</span></strong>
            </p>
          </td>
          <td width="76" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">实用量</span></strong>
            </p>
          </td>
          <td width="84" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">损耗量</span></strong>
            </p>
          </td>
          <td width="87" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">总公摊量</span></strong>
            </p>
          </td>
          <td width="66" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">单价</span></strong>
            </p>
          </td>
          <td width="86" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">公摊总金额</span></strong>
            </p>
          </td>
          <td width="73" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">公摊模式</span></strong>
            </p>
          </td>
          <td width="67" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">总基数</span></strong>
            </p>
          </td>
          <td width="62" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">公摊系数</span></strong>
            </p>
          </td>
          <td width="55" valign="center" nowrap="" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top-width: 1px; border-top-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0); background: rgb(241, 241, 241);">
            <p style=";text-align:center;vertical-align:middle">
              <strong><span style="font-family: 宋体;font-size: 10px">备注</span></strong>
            </p>
          </td>
        </tr>
        <tr v-for="(item, index) in meter_list" :key="index">
          <td width="202" valign="center" nowrap="" style="padding: 0px 7px; border-left-width: 1px; border-left-color: rgb(0, 0, 0); border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px">{{item.meter_name}}</span>
            </p>
          </td>
          <td width="85" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px">{{item.last_read_number}}</span>
            </p>
          </td>
          <td width="70" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px">{{item.read_number}}</span>
            </p>
          </td>
          <td width="71" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px">{{item.magnification}}</span>
            </p>
          </td>
          <td width="76" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px">{{item.dosage_number}}</span>
            </p>
          </td>
          <td width="84" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px">{{item.xs_accumulate_dosage_number}}</span>
            </p>
          </td>
          <td width="87" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style=";text-align:center;vertical-align:middle">
              <span style="font-family: 宋体;font-size: 10px">{{item.total_dosage_number}}</span>
            </p>
          </td>
          <td width="66" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px">{{item.current_price}}</span>
            </p>
          </td>
          <td width="86" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style=";text-align:center;vertical-align:middle">
              <span style="font-family: 宋体;font-size: 10px">{{item.allocated_amount}}</span>
            </p>
          </td>
          <td width="73" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px">{{item.apportion_type_name}}</span>
            </p>
          </td>
          <td width="67" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px">{{item.proportion_total}}</span>
            </p>
          </td>
          <td width="62" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style=";text-align:center;vertical-align:middle">
              <span style="font-family: 宋体;font-size: 10px">{{floatToFixed(item.ft_xs,publicity.coefficient_precision)}}</span>
            </p>
          </td>
          <td width="55" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px">{{item.remarks}}</span>
            </p>
          </td>
        </tr>
        <tr style="height:32px">
          <td width="427" valign="center" nowrap="" colspan="4" style="padding: 0px 7px; border-left-width: 1px; border-left-color: rgb(0, 0, 0); border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);"></td>
          <td width="76" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);"></td>
          <td width="84" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);"></td>
          <td width="87" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);"></td>
          <td width="66" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);"></td>
          <td width="86" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);"></td>
          <td width="73" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);"></td>
          <td width="67" valign="center" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);"></td>
          <td width="117" valign="center" colspan="2" style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: rgb(0, 0, 0); border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style="text-align:center">
              <span style="font-family: 宋体;font-size: 10px;color:#ff0000;">{{floatToFixed(all_xs,publicity.coefficient_precision)}} {{coefficient_unit_name||'[单位]'}}</span>
            </p>
          </td>
        </tr>
        </tbody>
      </table>
      <p>
        <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
      </p>
      <table cellspacing="0">
        <tbody>
        <tr class="firstRow">
          <td width="75" valign="top" style="padding: 0px 7px; border-width: initial; border-style: none; border-color: initial;">
            <p>
              <span style="font-family:宋体;font-size:12px"><span style="font-family:Calibri"></span></span>
            </p>
          </td>
          <td width="1009" valign="top" style="padding: 0px 7px; border-width: initial; border-style: none; border-color: initial;">
            <p>
              <span style="font-family:宋体;font-size:12px"><span style="font-family:Calibri">* </span><span style="font-family:宋体">总公摊量 </span><span style="font-family:Calibri">= </span><span style="font-family:宋体">实用量 ＋ 损耗量</span></span>
            </p>
            <p>
              <span style="font-family:宋体;font-size:12px"><span style="font-family:Calibri">* </span><span style="font-family:宋体">公摊总金额 </span><span style="font-family:Calibri">= </span><span style="font-family:宋体">总公摊量 × 单价</span></span>
            </p>
            <p>
              <span style="font-family:宋体;font-size:12px"><span style="font-family:Calibri">* </span><span style="font-family:宋体">公摊系数 </span><span style="font-family:Calibri">= </span><span style="font-family:宋体">公摊总金额 ÷ 总基数（总面积</span><span style="font-family:Calibri">/</span><span style="font-family:宋体">总户数</span><span style="font-family:Calibri">/</span><span style="font-family:宋体">总楼层</span><span style="font-family:Calibri">/</span><span style="font-family:宋体">总用量）</span></span>
            </p>
          </td>
        </tr>
        <tr>
          <td width="75" valign="top" style="padding: 0px 7px; border-width: initial; border-style: none; border-color: initial;"></td>
          <td width="1009" valign="top" style="padding: 0px 7px; border-width: initial; border-style: none; border-color: initial;">
            <p style="text-align:right">
              <span style="font-family:宋体;font-size:12px"><span style="font-family:Calibri;color:#ff0000">{{publicity.signature_unit||'[公示落款单位]'}}</span></span>
            </p>
            <p style="text-align:right">
              <span style="font-family:宋体;font-size:12px"><span style="font-family:Calibri">{{date_today}}</span></span>
            </p>
          </td>
        </tr>
        </tbody>
      </table>
      <p>
        <span style="font-family: 宋体;color: rgb(102, 102, 102);letter-spacing: 0;font-size: 12px">如需了解您家的具体水电分摊详情，请扫码二维码查阅</span>
      </p>
      <p>
        <span style="font-family: 宋体;color: rgb(102, 102, 102);letter-spacing: 0;font-size: 12px"><span style="font-family:宋体">如对以上公示有任何意见，请与项目前台电话</span><span style="font-family:Consolas;color:#ff0000">{{publicity.front_phone||'[前台电话]'}}</span><span style="font-family:宋体">咨询</span></span>
      </p>
    </div>
</template>

<script>
import moment from "moment";
import SelectProjectTreeComponent from "../../meter/components/SelectProjectTreeComponent";

export default {
  name: "MeterOrderPublicityTemplate",
  components: {SelectProjectTreeComponent},
  inject: ['mainObj'],
  props:{
    publicity: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      year_month: moment().format("YYYY年MM月"),
      date_today: moment().format("YYYY年MM月DD日"),
      meter_list: [
        {
          meter_name: "电表1",
          last_read_number: "1",
          read_number: "100",
          magnification: "100",
          dosage_number: "100",
          xs_accumulate_dosage_number: "100",
          total_dosage_number: "100",
          current_price: "100",
          allocated_amount: "100",
          apportion_type_name: "平均分摊",
          proportion_total: "100",
          ft_xs: 0.123456789,
          remarks: "",
        },
      ],
      coefficient_unit_obj:{
        1:"元/户",
        2:"元/平方米",
        3:"元/立方米",
        4:"元/吨",
        5:"元/度",
        6:"元/楼层",
      }
    }
  },
  computed: {
    all_xs() {
      let all_xs = 0;
      this.meter_list.forEach(item => {
        all_xs += item.ft_xs;
      });
      return all_xs.toFixed(6);
    },
    coefficient_unit_name() {
      return this.coefficient_unit_obj[this.publicity.coefficient_unit];
    },
  },
  methods: {
    floatToFixed(num, pos) {
      let pow = Math.pow(10, pos);
      return Math.round(num * pow) / pow;
    }
  }
}
</script>

<style lang="scss" scoped>
.meter-order-publicity-template{
  margin: 10px;
  padding: 10px;
  border: 1px solid #777777;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderPublicityTemplate.vue